import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  deleteProgram,
  fetchPrograms,
  publishProgram,
} from "../../store/ProgramSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  Card,
  Typography,
  Button,
  CardBody,
  CardFooter,
  Avatar,
  IconButton,
} from "@material-tailwind/react";
import moment from "moment";
import { toast } from "react-toastify";
import DeleteConfirmation from "../ConfirmBox";
import { AllPrograms } from "../../interfaces/Program";

const TABLE_HEAD = [
  "",
  "TITLE",
  "TOTAL COUNSELLINGS",
  "BOOKED SLOTS",
  "START DATE",
  "COST",
  "ACTIONS",
];

const ListView = () => {
  const dispatch = useDispatch<any>();
  const [sortConfig, setSortConfig] = useState<{
    column: string | null;
    sortOrder: "asc" | "desc";
  }>({ column: null, sortOrder: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState<string | null>(null);
  const itemsPerPage = 8;

  useEffect(() => {
    dispatch(fetchPrograms({ search: "",limit: 8 }));
  }, [dispatch]);

  const { data, loading, error } = useSelector(
    (state: RootState) => state.programs
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        {loading && (
          <div
            className="border-t-4 border-solid h-16 w-16 border-b-4 border-r-4 border-l-4 rounded-full animate-spin"
            style={{ borderColor: "#B4804A" }}
          />
        )}
      </div>
    );
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const handleDelete = (programId: string) => {
    // Dispatch the delete action
    dispatch(deleteProgram(programId)).then(() => {
      dispatch(fetchPrograms({ search: "" })).then(() => {
        toast.success("Successfully Deleted");
      });
    });
  };
  const handlePublish = (programId: string, publish: boolean) => {
    dispatch(publishProgram({ programId, publish })).then(() => {
      dispatch(fetchPrograms({ search: "" })).then(() => {
        // toast.success(
        //   publish ? "Successfully Published" : "Successfully Unpublished"
        // );
      });
    });
  };

  const mapColumnToCamelCase = (column: string) => {
    const columnMappings: Record<string, string> = {
      TITLE: "title",      
      "TOTAL COUNSELLINGS": "totalCounsellings",
      "BOOKED SLOTS": "maxParticipants",
      "START DATE": "startDate",
      COST: "cost",
    };

    return columnMappings[column];
  };

  const parsedData = typeof data === "string" ? JSON.parse(data) : data;
  if (!parsedData?.programs || parsedData.programs.length === 0) {
    return <div>No programs available</div>;
  }

  const handleSort = (column: string) => {
    if (column === "" || column === "ACTIONS" || column === "COST") {
      return;
    }
    const updatedColumnName = mapColumnToCamelCase(column);
    const sortOrder =
      updatedColumnName === sortConfig.column && sortConfig.sortOrder === "asc"
        ? "desc"
        : "asc";
    setSortConfig({ column: updatedColumnName, sortOrder });
    dispatch(fetchPrograms({ sortBy: `${updatedColumnName}:${sortOrder}` }));
  };
  const handlePagination = (page: number, limit: number) => {
    dispatch(fetchPrograms({ page, limit }));
  };

  const handleNextClick = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    handlePagination(nextPage, itemsPerPage);
  };

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      const previousPage = currentPage - 1;
      setCurrentPage(previousPage);
      handlePagination(previousPage, itemsPerPage);
    }
  };

  const handleCancel = () => {
    setDeleteItemId(null);
  };

  return (
    <>
      <div className=" bg-white sm:px-7.5">
        
          <Card className="h-full w-full relative shadow-none   z-10">
            <CardBody className="overflow-hidden px-6  min-h-[550px]">
              <div className=" w-full overflow-hidden ">
                <table className="w-full table-auto  ">
                  <thead>
                    <tr className="bg-gray-2 text-left border-b-2">
                      {TABLE_HEAD.map((head) => (
                        <th
                          key={head}
                          className="min-w-[80px] py-4 px-4 font-bold text-[#7E8299] uppercase cursor-pointer"
                          onClick={() => handleSort(head)}
                        >
                          <div className="flex items-center">
                            <Typography
                              variant="small"
                              className="font-semibold leading-none text-[#7E8299] opacity-70"
                            >
                              {head}
                            </Typography>
                            <span className="ml-1"></span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {parsedData?.programs?.map((AllPrograms: AllPrograms) => (
                      <tr key={AllPrograms.id} className="border-b">
                        <td className="py-1 px-4">
                          <div className="flex items-center">
                            <Avatar
                              src={AllPrograms.icon}
                              alt={AllPrograms.title}                              
                              className="border border-blue-gray-50 w-10 h-10 bg-blue-gray-50/50 object-contain "
                            />
                          </div>
                        </td>
                        <td className="py-1 px-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {AllPrograms.title}
                          </Typography>
                        </td>
                        {/* <td className="py-1 px-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {AllPrograms.id}
                          </Typography>
                        </td> */}
                        <td className="py-1 px-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {AllPrograms.totalCounsellings}
                          </Typography>
                        </td>
                        <td className="py-1 px-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {AllPrograms.maxParticipants}
                          </Typography>
                        </td>
                        <td className="py-1 px-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {moment(AllPrograms.startDate).format(
                              "DD MMM, YYYY"
                            )}
                          </Typography>
                        </td>
                        <td className="py-1 px-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {"$ " + AllPrograms.cost}
                          </Typography>
                        </td>

                        <td className="py-1 px-4">
                          <div className="group  dropdown text-center bg-white">
                            <div className="p-3 text-center align-middle justify-center">
                              <button
                                type="button"
                                className="z-10 relative mx-auto justify-center"
                                id="options-menu"
                              >
                                <img
                                  src="./images/dots.png"
                                  className="m-auto"
                                  alt="action"
                                />
                              </button>

                              <div className="group-hover:block dropdown-menu h-auto hidden origin-top-right text-left absolute right-7 mt-1 w-24 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-20">
                                <div
                                  className="py-1"
                                  role="menu"
                                  aria-orientation="vertical"
                                  aria-labelledby="options-menu"
                                >
                                  <button
                                    onClick={() =>
                                      handlePublish(
                                        AllPrograms.id,
                                        !AllPrograms?.publish
                                      )
                                    }
                                    className="block px-4 py-2 text-sm text-[#102832] hover:bg-gray-100"
                                    role="menuitem"
                                  >
                                    {" "}
                                    {AllPrograms?.publish
                                      ? "Unpublish"
                                      : "Publish"}
                                  </button>
                                  <Link
                                    to={`edit/${AllPrograms.id}`}
                                    className="block px-4 py-2 text-sm text-[#102832] hover:bg-gray-100"
                                    role="menuitem"
                                  >
                                    Edit
                                  </Link>
                                  <button
                                    onClick={() =>
                                      setDeleteItemId(AllPrograms.id)
                                    }
                                    className="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                                    role="menuitem"
                                  >
                                    Remove
                                  </button>
                                  {deleteItemId === AllPrograms.id && (
                                    <DeleteConfirmation
                                      onConfirm={() =>
                                        handleDelete(AllPrograms.id)
                                      }
                                      onCancel={handleCancel}
                                      message={AllPrograms.title}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
            <CardFooter className="flex items-center justify-between  mx-6 px-4">
              <div className="flex float-right ml-auto items-center gap-2">
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={handlePreviousClick}
                  disabled={currentPage === 1}
                  className={`disabled:cursor-not-allowed ${
                    currentPage === 1 ? "text-gray-500" : ""
                  }`}
                >
                  Previous
                </Button>
                <IconButton
                  variant="outlined"
                  size="sm"
                  className="cursor-default"
                >
                  {currentPage}
                </IconButton>
                <Button
                  variant="outlined"
                  onClick={handleNextClick}
                  disabled={(currentPage + 1) > parsedData?.totalPages}
                  size="sm"
                  className={`disabled:cursor-not-allowed disabled:text-gray-500`}
                >
                  Next
                </Button>
              </div>
            </CardFooter>
          </Card>
        </div>
      
    </>
  );
};

export default ListView;
